import React from 'react';
import { getCurrentLayerName } from '../../../selectors';
import { getCurrentSeasonYear } from '../../../selectors/seasonSelectors';
import { useAppSelector } from '../../../utils';
import styles from './SplitViewHeader.css';

export type SplitViewHeaderProps = {
  headerDetail?: string | React.ReactElement;
  index: number;
};

export const SplitViewHeader = ({ headerDetail, index }: SplitViewHeaderProps) => {
  const layer = useAppSelector(state => getCurrentLayerName(state, { index }));
  const year = useAppSelector(state => getCurrentSeasonYear(state, { index }));
  return (
    <div className={styles.header} data-test-id="split-view-header">
      <h3 data-test-id="dmb-split-view-header-layer">{layer}</h3>
      {headerDetail ? (
        <div data-test-id="dmb-split-view-header-detail">{headerDetail}</div>
      ) : (
        <time data-test-id="dmb-split-view-header-detail">{year}</time>
      )}
    </div>
  );
}
